import { useEffect, useState } from 'react'
import { Pose, SeniorImage } from '../../../models'

const useSeniorImages = (ids, isSenior = true) => {
  const [studentImages, setStudentImages] = useState(null)

  useEffect(() => {
    if (isSenior) {
      SeniorImage
        .where({ id: ids })
        .all()
        .then((res) => setStudentImages(res.data))
    } else {
      Pose
        .where({ id: ids })
        .all()
        .then((res) => setStudentImages(res.data))
    }
  }, [JSON.stringify(ids), isSenior])

  return studentImages
}

export default useSeniorImages
